import React from 'react';
import {Dialog} from '@rneui/themed';

import Button from '../../components/ui-controls/Button';
import Text from '../../components/ui-controls/Text';

const SignInRequiredModal = ({
  isVisible,
  onPress,
  onBackdropPress,
}: {
  isVisible: boolean;
  onPress: () => void;
  onBackdropPress: () => void;
}) => (
  <Dialog isVisible={isVisible} onBackdropPress={onBackdropPress}>
    <Text style={{marginBottom: 16, textAlign: 'center'}}>
      TO PLACE AN ORDER YOU NEED TO SIGN IN OR CREATE AN ACCOUNT
    </Text>
    <Button
      onPress={onPress}
      title="SIGN IN OR CREATE AN ACCOUNT"
      buttonStyle={{width: '100%'}}
    />
    {/* </Dialog.Actions> */}
  </Dialog>
);

export default SignInRequiredModal;
